// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import $ from 'jquery';

// Actions
import { actions } from './actions';

// Components
import { CancelButton, Button } from 'components/widgets/buttons';

// Component
class Modal extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool,
    bootstrapOptions: PropTypes.object, // Bootstrap options passed to the modal
    onConfirm: PropTypes.func, // Function called if the user confirms
    onCancel: PropTypes.func, // Function called if the user cancels
    confirmationString: PropTypes.string, // String that must be typed into an input in order to confirm
    title: PropTypes.string, // The modal title
    body: PropTypes.node, // The modal body
    confirmText: PropTypes.string, // The text on the confirm button
    cancelText: PropTypes.string, // The text on the cancel button
    confirmButtonClasses: PropTypes.string.isRequired, // The class for the confirm button.
    // Set to btn-danger if confirm is a dangerous action
    hideOnConfirm: PropTypes.bool // True if the modal should hide itself when
    // the user confirms. If this is set to false, the modal caller is required to manually
    // hide the modal using modalActions.hideModal when appropriate
  };

  static defaultProps = {
    confirmText: 'Okay',
    cancelText: 'Cancel',
    onCancel: actions.hideModal,
    confirmButtonClasses: 'btn-primary',
    hideOnConfirm: true
  };

  constructor() {
    super();
    this.onConfirm = this.onConfirm.bind(this);

    this.state = {};
  }

  componentDidMount() {
    // Create a listener which will call the modalHidden reducer to clear the modal state
    // when the modal has finished hiding
    $(ReactDOM.findDOMNode(this)).on('hidden.bs.modal', actions.modalHidden);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showModal && !nextProps.showModal) {
      $(ReactDOM.findDOMNode(this)).modal('hide'); // Hide the modal
      setTimeout(() => $('.fade.show').removeClass('show'), 0);
    } else if (!this.props.showModal && nextProps.showModal) {
      $(ReactDOM.findDOMNode(this)).modal('show'); // Show the modal
      setTimeout(() => $('.fade.in').addClass('show'), 150);
    } else if (this.props.bootstrapOptions !== nextProps.bootstrapOptions) {
      $(ReactDOM.findDOMNode(this)).modal(this.props.bootstrapOptions); // Reinitialize the modal with new options
    }
  }

  onConfirm() {
    if (this.props.hideOnConfirm) actions.hideModal();

    this.props.onConfirm();
  }

  render() {
    const {
      onCancel,
      title,
      body,
      confirmText,
      cancelText,
      confirmationString,
      confirmButtonClasses
    } = this.props;

    const { confirmationText } = this.state;
    const safeToConfirm = !confirmationString || (confirmationString === confirmationText);

    return (
      <div className="modal fade" tabIndex="-1" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title mt-0">{title}</h4>
            </div>
            { body &&
              <div className="modal-body">
                {body}

                { confirmationString &&
                  <div className="my-3">
                    <p>
                      To confirm you want to do this enter this below:<br />
                      <span className="font-weight-bold">{confirmationString}</span>
                    </p>
                    <input className="font-control" onChange={event => this.setState({ confirmationText: event.target.value })} />
                  </div>
                }
              </div>
            }
            <div className="modal-footer">
              <CancelButton onClick={onCancel}>{cancelText}</CancelButton>
              <Button disabled={!safeToConfirm} className={confirmButtonClasses} onClick={this.onConfirm}>{confirmText}</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    showModal: state.modals.showModal,
    ...state.modals.modalState
  };
}


// Exports
export default connect(mapStateToProps)(Modal);
